import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import dayOfYear from 'dayjs/plugin/dayOfYear';
import isLeapYear from 'dayjs/plugin/isLeapYear';
import isoWeek from 'dayjs/plugin/isoWeek';
import isoWeeksInYear from 'dayjs/plugin/isoWeeksInYear';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';

// UTC must be registered before timezone.
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);
dayjs.extend(dayOfYear);
dayjs.extend(localizedFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(updateLocale);
dayjs.extend(isoWeeksInYear);
dayjs.extend(isLeapYear);

dayjs.updateLocale('en', {
    weekStart: 1,
});

/**
 * The project's configured Day.js entry point.
 *
 * Prefer importing this instead of importing `dayjs` directly so every
 * consumer uses the same plugins and locale configuration.
 */
export const datetime = dayjs;

/**
 * Returns the first instant of an ISO week (Monday).
 */
export function getStartOfWeek(year: string | number, week: string | number) {
    return dayjs()
        .year(Number(year))
        .month(0)
        .date(4)
        .isoWeek(Number(week))
        .startOf('isoWeek');
}

/**
 * Returns the last instant of an ISO week (Sunday).
 */
export function getEndOfWeek(year: string | number, week: string | number) {
    return dayjs()
        .year(Number(year))
        .month(0)
        .date(4)
        .isoWeek(Number(week))
        .endOf('isoWeek');
}

export type { ConfigType, Dayjs, ManipulateType, OpUnitType, QUnitType } from 'dayjs';

export default datetime;
